'use strict';

/**
 * List of available easing names available through jQuery and via 'module.exports' (e.g. Ease.inOutCubic):
 * <ul>
 * <li>linear
 * <li>swing
 * <li>inQuad
 * <li>outQuad
 * <li>inOutQuad
 * <li>inCubic
 * <li>outCubic
 * <li>inOutCubic
 * <li>inQuart
 * <li>outQuart
 * <li>inOutQuart
 * <li>inQuint
 * <li>outQuint
 * <li>inOutQuint
 * <li>inExpo
 * <li>outExpo
 * <li>inOutExpo
 * <li>inSine
 * <li>outSine
 * <li>inOutSine
 * <li>inCirc
 * <li>outCirc
 * <li>inOutCirc
 * <li>inElastic
 * <li>outElastic
 * <li>inOutElastic
 * <li>inBack
 * <li>outBack
 * <li>inOutBack
 * <li>inBounce
 * <li>outBounce
 * <li>inOutBounce
 * </ul>
 * 
 * These are based on jQueryUI. Documentation (with nice graphs): http://api.jqueryui.com/easings/
 */


/*! jQuery UI - v1.11.4 - 2016-03-12
* http://jqueryui.com
* Includes: effect.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */
// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var Ease = {};
var baseEasings = {};

// Create an object that contains all base easing functions
var baseEasingNames = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
for (var i in baseEasingNames) {
	addBaseEasingFn(i, baseEasingNames[i]);
}
function addBaseEasingFn(i, name) {
	baseEasings[name] = function(p) {
		return Math.pow(p, i + 2);
	};
}

// Add a few specific ones;
baseEasings.Sine = function(p) {
	return 1 - Math.cos( p * Math.PI / 2 );
};
baseEasings.Circ = function(p) {
	return 1 - Math.sqrt( 1 - p * p );
};
baseEasings.Elastic = function(p) {
	return p === 0 || p === 1 ? p :
		-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
};
baseEasings.Back = function(p) {
	return p * p * ( 3 * p - 2 );
};
baseEasings.Bounce = function(p) {
	var pow2, bounce = 4;
	while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
	return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
};

// Iterate through the base easing functions and create 'in' 'out' and 'inOut' variations
for (var name in baseEasings) {
	if (baseEasings.hasOwnProperty(name)) {
		addVariations(name, baseEasings[name])
	}
}
function addVariations(name, easeFn) {
	addEasingFn('in' + name, easeFn);
	addEasingFn('out' + name, function(p) {
		return 1 - easeFn( 1 - p );
	});
	var inOutFn = addEasingFn('inOut' + name, function(p) {
		return p < 0.5 ?
				easeFn( p * 2 ) / 2 :
				1 - easeFn( p * -2 + 2 ) / 2;
	});
}
// TODO Create a cubic bezier variations that provides a lot of flexiblity. E.g: http://cubic-bezier.com/ .. Here: https://github.com/gre/bezier-easing/blob/master/src/index.js

// Add 'linear' and 'swing'
addEasingFn('linear', function(p) {
	return p;
});
addEasingFn('swing', function(p) {
	return 0.5 - Math.cos( p * Math.PI ) / 2;
});

function addEasingFn(name, fn) {
	Ease[name] = fn;
	if (window.jQuery) {
		// TODO Only works if jQuery is global. Should add away for another module to pass a reference for setup.
		window.jQuery.easing[name] = fn;
	}
	return fn;
};

// Change default easing in jQuery
if (window.jQuery) {
	window.jQuery.easing.def = 'outQuad';
}

module.exports = Ease;
